"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _constants = require("./constants");

var _Toast = _interopRequireDefault(require("./Toast.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Toast["default"]);

var Toast = /*#__PURE__*/function (_React$Component) {
  _inherits(Toast, _React$Component);

  var _super = _createSuper(Toast);

  function Toast(props) {
    var _this;

    _classCallCheck(this, Toast);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeToastTimer", null);

    _defineProperty(_assertThisInitialized(_this), "onAnimationEnd", function () {
      var _this$props = _this.props,
          autoClose = _this$props.autoClose,
          closeToast = _this$props.closeToast;
      clearTimeout(_this.closeToastTimer);

      if (autoClose) {
        _this.closeToastTimer = setTimeout(function () {
          return closeToast();
        }, autoClose);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toastIcon", function (type) {
      switch (type) {
        case _constants.TYPE.NOTICE:
          return 'circle-fill-check';

        case _constants.TYPE.ALERT:
          return 'stop-sign';

        case _constants.TYPE.INFO:
          return 'circle-fill-info';

        case _constants.TYPE.WARNING:
        default:
          return 'warning';
      }
    });

    _this.state = {
      isRunning: true
    };
    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onOpen = this.props.onOpen;
      onOpen();
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var nextIsDocumentHidden = _ref.isDocumentHidden;
      var isDocumentHidden = this.props.isDocumentHidden;

      if (isDocumentHidden !== nextIsDocumentHidden) {
        this.setState({
          isRunning: !nextIsDocumentHidden
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onClose = this.props.onClose;
      onClose();
      clearTimeout(this.closeToastTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actionTitle = _this$props2.actionTitle,
          autoClose = _this$props2.autoClose,
          children = _this$props2.children,
          closeToast = _this$props2.closeToast,
          closeOnClick = _this$props2.closeOnClick,
          onActionClick = _this$props2.onActionClick,
          type = _this$props2.type,
          updateId = _this$props2.updateId,
          isDocumentHidden = _this$props2.isDocumentHidden,
          onClose = _this$props2.onClose,
          onOpen = _this$props2.onOpen,
          props = _objectWithoutProperties(_this$props2, ["actionTitle", "autoClose", "children", "closeToast", "closeOnClick", "onActionClick", "type", "updateId", "isDocumentHidden", "onClose", "onOpen"]),
          isRunning = this.state.isRunning,
          onAnimationEnd = this.onAnimationEnd;

      var style = {
        animationPlayState: isRunning ? 'running' : 'paused'
      };
      var buttonClasses = [cx('toast__button'), {
        'button--secondary-success': type === _constants.TYPE.NOTICE,
        'button--secondary-warning': type === _constants.TYPE.WARNING,
        'button--secondary-info': type === _constants.TYPE.INFO,
        'button--secondary-alert': type === _constants.TYPE.ALERT
      }];
      var classes = cx('toast', {
        'toast--notice': type === _constants.TYPE.NOTICE,
        'toast--alert': type === _constants.TYPE.ALERT,
        'toast--warning': type === _constants.TYPE.WARNING,
        'toast--info': type === _constants.TYPE.INFO
      });

      if (closeOnClick) {
        props.onClick = function () {
          return closeToast();
        };

        props.onKeyPress = function () {
          return closeToast();
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: classes,
        style: style,
        onAnimationEnd: onAnimationEnd
      }, props), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('toast__icon')
      }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        "aria-hidden": "true",
        name: this.toastIcon(type)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('toast__message')
      }, children, actionTitle && /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
        appearance: "secondary",
        className: buttonClasses,
        hasDanger: type === 'alert',
        size: "x-small",
        onClick: onActionClick
      }, actionTitle)), !autoClose && /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
        appearance: "utility",
        "aria-label": "close",
        className: cx('toast__dismiss'),
        isDark: true,
        onClick: closeToast,
        onKeyPress: closeToast
      }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
        name: "x-dismiss",
        title: "Close alert"
      })));
    }
  }]);

  return Toast;
}(_react["default"].Component);

Toast.propTypes = {
  actionTitle: _propTypes["default"].string,

  /**
   * Disable or set autoClose delay
   */
  autoClose: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]).isRequired,

  /** Content for the toast */
  children: _propTypes["default"].node.isRequired,
  closeOnClick: _propTypes["default"].bool.isRequired,
  // eslint-disable-line react/boolean-prop-naming

  /** Remove Toast on animation end */
  closeToast: _propTypes["default"].func.isRequired,
  isDocumentHidden: _propTypes["default"].bool,

  /** type of the toast */
  type: _propTypes["default"].oneOf([_constants.TYPE.NOTICE, _constants.TYPE.ALERT, _constants.TYPE.INFO, _constants.TYPE.WARNING]),
  updateId: _propTypes["default"].number,
  onActionClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
};
Toast.defaultProps = {
  actionTitle: null,
  isDocumentHidden: false,
  type: _constants.TYPE.NOTICE,
  updateId: null,
  onActionClick: null,
  onClose: function onClose() {},
  onOpen: function onOpen() {}
}; // force bump :)

var _default = Toast;
exports["default"] = _default;